import { Target, Brain, ShieldHalf, Unlock } from "lucide-react";

const PILLARS = [
  {
    id: "career-alignment",
    icon: Target,
    title: "Precision Career Mapping",
    description: "Reduces years of trial-and-error by matching your psychological traits to hundreds of modern career paths.",
    badge: "84% Higher Satisfaction",
    accent: "from-indigo-500/10 to-indigo-500/20 border-indigo-200 text-indigo-600",
  },
  {
    id: "cognitive-clarity",
    icon: Brain,
    title: "Cognitive & Work-Style Clarity",
    description: "Uncovers your learning dynamics, problem-solving speed, and how you hold up under stress.",
    badge: "Deeper Self-Awareness",
    accent: "from-cyan-500/10 to-cyan-500/20 border-cyan-200 text-cyan-600",
  },
  {
    id: "futureproof-skills",
    icon: ShieldHalf,
    title: "Futureproofing Against Automation",
    description: "Identifies irreplaceable human traits — empathy, strategic synthesis, creative grit — that AI can't easily replicate.",
    badge: "AI-Resilient Archetypes",
    accent: "from-fuchsia-500/10 to-fuchsia-500/20 border-fuchsia-200 text-fuchsia-600",
  },
  {
    id: "paralysis-breaker",
    icon: Unlock,
    title: "Overcoming Career Choice Paralysis",
    description: "Transforms overwhelming options into a curated, prioritised action pathway you can actually act on.",
    badge: "Clarity Over Confusion",
    accent: "from-amber-500/10 to-amber-500/20 border-amber-200 text-amber-600",
  },
];

export default function WhyAssessmentMatters() {
  return (
    <section className="bg-slate-50 py-24 px-6" data-testid="why-assessment-matters-section">
      <div className="max-w-6xl mx-auto">
        <p className="text-xs uppercase tracking-[0.2em] font-medium text-indigo-600 mb-3 text-center">Why It Matters</p>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 text-center max-w-3xl mx-auto mb-16">
          Why Personality Assessment Matters in This Competitive Age
        </h2>
        <div className="grid sm:grid-cols-2 gap-6">
          {PILLARS.map((p) => (
            <div
              key={p.id}
              data-testid={`why-matters-pillar-${p.id}`}
              className={`relative rounded-2xl border bg-gradient-to-br p-8 hover:-translate-y-1 transition-transform ${p.accent}`}
            >
              <div className="h-12 w-12 rounded-xl bg-white flex items-center justify-center mb-5 shadow-sm">
                <p.icon className="h-6 w-6" />
              </div>
              <span className="inline-block text-[11px] font-bold uppercase tracking-wide bg-white/80 rounded-full px-3 py-1 mb-3">{p.badge}</span>
              <h3 className="font-heading text-lg font-semibold text-slate-900 mb-2">{p.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{p.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
